<template>
  <el-dialog title="Gerar Demonstrativo" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="375px">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="">
            <el-select v-model="form.geracao" style="width:100%;">
                <el-option label="Gerar Pdf" value="PDF"/>
                <el-option label="Enviar por e-mail" value="E_MAIL"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item>
            <el-radio-group v-model="form.duasVias">
              <el-radio :label="false">1 Via</el-radio>
              <el-radio :label="true">2 Vias</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="form.geracao == 'E_MAIL'">
        <el-col :span="24">
          <el-form-item label="E-mail">
            <el-input v-model="form.email" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="gerarDemonstrativoHandler" type="primary" size="small" v-if="form.geracao == 'PDF'" round class="btn-box-shadow">Gerar</el-button>
      <el-button @click="enviarDemonstrativoHandler" type="primary" size="small" v-if="form.geracao == 'E_MAIL'" round class="btn-box-shadow">Enviar</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  props: {
    recibo: Object,
    cliente: Object,
    visibility: Boolean
  },
  watch: {
      cliente(newValue) {
            this.form.email = newValue.email
      }
  },
  data() {
    return {
      form: {
            geracao: "PDF",
            duasVias: false,
            email: ""
        }
    }
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
        'gerarDemonstrativoCliente',
        'enviarDemonstrativoCliente'
    ]),
    gerarDemonstrativoHandler() {
        let payload = { id: this.recibo.id, imprimirDuasVias: this.form.duasVias, reciboLocatarioContratoFinalizado: this.recibo.reciboLocatarioContratoFinalizado }
        
        this.showLoading();
        this.gerarDemonstrativoCliente(payload)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    window.open(resultado.item, "_blank");
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
            this.$emit('close');
        }).catch(() => {
            this.hideLoading();
        });
    },
    enviarDemonstrativoHandler() {
        const payload = {
          id: this.recibo.id,
          imprimirDuasVias: this.form.duasVias,
        };

        this.showLoading();
        this.enviarDemonstrativoCliente(payload)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
            this.$emit('close');
        }).catch(() => {
            this.hideLoading();
        });
    },
    fechar() {
      this.$emit('close');
    },
  }
}
</script>
